import AntTable, { ColumnType as AntColumnType } from 'antd/lib/table';

export interface ColumnType<RecordType = unknown> extends AntColumnType<RecordType> {
  sortKey?: string;
}

export const Table = AntTable;
